import { useRef, useState, useEffect } from 'react';

export function useIsMobile() {
  const didCancel = useRef(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      if (didCancel.current) return;
      setIsMobile(window.innerWidth < 900);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      didCancel.current = true;
      window.removeEventListener('resize', handleResize, { passive: true, capture: true });
    };
  }, []); // eslint-disable-line

  return isMobile;
}
